import { createSlice } from '@reduxjs/toolkit';

const customerAuctionsSlice = createSlice({
  name: 'auctions',
  initialState: [] as number[],
  reducers: {
    updateAuctionsList(state, { payload }) {
      if (typeof payload === 'number') {
        state = Array.from(new Set([...state, payload]));
      } else {
        state = Array.from(new Set([...state, ...payload]));
      }
      return state;
    },
    clearAuctionsList(state) {
      state = [];
      return state;
    },
  },
});

export const { updateAuctionsList, clearAuctionsList } =
  customerAuctionsSlice.actions;
export default customerAuctionsSlice.reducer;
